import { m } from 'motion/react';
import { useState } from 'react';
import { itemVariants } from '../../../utils/framer';
import CenteredImageTextLink from '../../components/100page/CenteredImgTextLink';
import TextBlock from '../../components/100page/TextBlock';
import { ImageTypeEnum } from '../../components/carousel/types/CarouselTypes';
import AnimatedSection from '../../components/privatleasing/AnimatedSection';
import HeroPrivatLeasing from '../../components/privatleasing/HeroPrivatLeasing';
import ImgAndTextCarCard from '../../components/privatleasing/ImgAndTextCarCard';
import { TextBox } from '../../components/privatleasing/TextBox';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import Snippet from '../../components/Snippet';
import KIAImage from '../../components/ui/image/KIAImage';
import LinkButton from '../../components/ui/LinkButton';
import Carousel from '../carousel/carousel';
import {
  centerText,
  hero100Page,
  imgAndTextCarCard100Page,
  kiaImage100Page01,
  kiaImage100Page02,
  kiaImage100Page03,
  kiaImage100Page04,
  kiaImage100Page05,
  kiaImageOne100Page,
  subHeadingOne100Page,
  text100page001,
  textBox100Page,
  twoComponentsText100Page,
  twoComponentsTextandImg100Page01,
  twoComponentsTextandImg100Page02,
  twoComponentsTextandImg100Page03,
  twoComponentsTextandImg100Page04,
} from './page100-copy';

const Page100 = () => {
  const [hideControls] = useState(true);
  return (
    <main className="relative">
      <div>
        <HeroPrivatLeasing {...hero100Page} />
      </div>
      <div className="w-full max-w-screen-kia mx-auto">
        <div className="max-w-7xl mx-auto">
          <p className="font-light text-[18px] px-2 mt-[28px]">
            {text100page001}
          </p>
        </div>

        <section>
          <TextBox {...textBox100Page} />
        </section>
        <section>
          <ImgAndTextCarCard {...imgAndTextCarCard100Page} />
        </section>
        <AnimatedSection id="car-models" className="my-6">
          <m.h2
            className="text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3 whitespace-pre-line break-normal"
            style={{ hyphens: 'none', overflowWrap: 'normal' }}
            variants={itemVariants}
          >
            {subHeadingOne100Page.text}
          </m.h2>
          <m.div variants={itemVariants}>
            <Carousel
              hideControls={hideControls}
              pricelist={false}
              fields="Upptäck bilen"
              heading=""
              imageType={ImageTypeEnum.STUDIO}
              fuelId="1,2"
              categoryIds=""
            />
          </m.div>
        </AnimatedSection>

        <AnimatedSection id="sub-hedings" className="mb-12">
          <m.h2
            className="text-center p-2 font-medium text-[30px] md:text-[40px] leading-[48px] mb-3 whitespace-pre-line break-normal"
            style={{ hyphens: 'none', overflowWrap: 'normal' }}
            variants={itemVariants}
          >
            Framtidens <br className="block md:hidden" /> energilösningar i din
            Kia.
          </m.h2>
        </AnimatedSection>
        <div className="mx-auto px-6">
          <div className="max-w-screen-sm mx-auto">
            <KIAImage {...kiaImageOne100Page} />
          </div>
          <section className="border-b pb-24 border-black/20 mx-auto px-6 w-full max-w-7xl">
            <TwoFlexibleComponentBox
              firstComponentWidth="col-span-4 "
              secondComponentWidth="col-span-4"
              mainBoxClassName="mx-auto w-full max-w-7xl"
              firstComponentClassName="p-0 lg:p-10 lg:pt-0"
              secondComponentClassName="p-0 lg:p-10 lg:pt-0"
              firstComponent={
                <div>
                  <h3 className="text-[20px]  md:text-[22px] leading-[28px] font-semibold mt-10 mb-6 ">
                    {twoComponentsText100Page.firstComponent.title}
                  </h3>
                  <p className="text-base md:text-[18px] font-light">
                    {twoComponentsText100Page.firstComponent.text}
                  </p>
                  <p className="mt-2 text-xs font-light text-gray-700">
                    {twoComponentsText100Page.firstComponent.disclaimer}
                  </p>
                </div>
              }
              secondComponent={
                <div>
                  <h3 className="text-[20px]  md:text-[22px] leading-[28px] font-semibold mt-10 mb-6 ">
                    {twoComponentsText100Page.secondComponent.title}
                  </h3>
                  <p className="text-base md:text-[18px] font-light">
                    {twoComponentsText100Page.secondComponent.text}
                  </p>
                  <LinkButton
                    className="h-12 mt-4"
                    {...twoComponentsText100Page.secondComponent.link}
                  />
                </div>
              }
            />
          </section>
        </div>
        <section className="border-b border-black/20 md:border-none p-4 mt-12 mx-auto w-full max-w-7xl">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-3 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={
              <TextBlock
                title={twoComponentsTextandImg100Page01.title}
                text={twoComponentsTextandImg100Page01.text}
                links={twoComponentsTextandImg100Page01.links}
                titleClassName="text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 "
                textClassName="text-[16px] md:text-[18px] leading-[24px] font-light"
              />
            }
            secondComponent={<KIAImage {...kiaImage100Page01} />}
          />
        </section>
        <section className="border-b border-black/20 md:border-none p-4 mx-auto w-full max-w-7xl">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName=" pt-0"
            secondComponentClassName="p-3 lg:p-10 lg:pt-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...kiaImage100Page02} />}
            secondComponent={
              <TextBlock
                title={twoComponentsTextandImg100Page02.title}
                text={twoComponentsTextandImg100Page02.text}
                links={twoComponentsTextandImg100Page02.links}
                titleClassName="text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 "
                textClassName="text-[16px] md:text-[18px] leading-[24px] font-light"
              />
            }
          />
        </section>
        <section className="border-b border-black/20 md:border-none p-4 mx-auto w-full max-w-7xl">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-3 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={
              <TextBlock
                title={twoComponentsTextandImg100Page03.title}
                text={twoComponentsTextandImg100Page03.text}
                links={twoComponentsTextandImg100Page03.links}
                titleClassName="text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 "
                textClassName="text-[16px] md:text-[18px] leading-[24px] font-light"
              />
            }
            secondComponent={<KIAImage {...kiaImage100Page03} />}
          />
        </section>
        <section className="border-b border-black/20 md:border-none p-4 mx-auto w-full max-w-7xl">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4"
            secondComponentWidth="col-span-4"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName=" pt-0"
            secondComponentClassName="p-3 lg:p-10 lg:pt-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...kiaImage100Page04} />}
            secondComponent={
              <TextBlock
                title={twoComponentsTextandImg100Page04.title}
                text={twoComponentsTextandImg100Page04.text}
                links={twoComponentsTextandImg100Page04.links}
                titleClassName="text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 "
                textClassName="text-[16px] md:text-[18px] lg:text-[20px] leading-[24px] font-light "
              />
            }
          />
        </section>
        <section>
          <CenteredImageTextLink
            image={<KIAImage {...kiaImage100Page05} />}
            title={centerText.title}
            text={centerText.text}
            link={centerText.link}
            linkClassName="font-medium"
          />
        </section>

        <Snippet page="100" />
      </div>
    </main>
  );
};

export default Page100;
